/**
 * Utils method for versions operations
 * 
 * Author: Andrea López
 */

import { useStore } from 'vuex';
import { IVersionsConfigJson, IVersionsConfig } from '../@types';

const versionConfig: IVersionsConfigJson = require('@/core/modules/arguments/data/arguments.json');
const versionConfigDefault: IVersionsConfig = require('./versions.config.js');

export function getVersionConfig (): string {
	// Local file
	if (versionConfig && versionConfig.version) {
		return versionConfig.version;
	}

	return versionConfigDefault.default;
}

export function getVersionApp (): string {
	const store = useStore();
	return store ? store.getters.get_appVersion : getVersionConfig();
}